import type { ChipProps } from '@mui/material';

export const RULE_KIND_LABELS: Record<string, string> = {
  REACTIVE: 'Acts on events',
  INFORMATIONAL: 'Informs only',
};

export const PRIORITY_LABELS: Record<string, string> = {
  P1: 'Critical',
  P2: 'High',
  P3: 'Normal',
  P4: 'Low',
};

export const PRIORITY_COLOR: Record<string, ChipProps['color']> = {
  P1: 'error',
  P2: 'warning',
  P3: 'info',
  P4: 'default',
};

// Single status-wording map; PO confirmed: keep Draft/Active/Deprecated (not Live/Retired).
export const OFFERING_STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  active: 'Active',
  deprecated: 'Deprecated',
};

// Single status-color map for ServiceOffering.status — the one source of truth,
// paired with OFFERING_STATUS_LABELS above.
export const OFFERING_STATUS_COLORS: Record<string, ChipProps['color']> = {
  draft: 'default',
  active: 'success',
  deprecated: 'warning',
};
